import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import PulseLoader from 'react-spinners/PulseLoader';

import CssConfirmDeletionDialog from './ConfirmDeletionDialog.scss';

function ConfirmDeletionDialog(props) {
  const { abortText, body, inProgress, onAgree, onClose, proceedText, title } = props;
  useStyles(CssConfirmDeletionDialog);
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="confirm-deletion"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText className="confirm-deletion__body" id="alert-dialog-description">
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="confirm-deletion__actions">
        <Button
          className="confirm-deletion__button confirm-deletion__button--cancel"
          size="large"
          onClick={onClose}
          variant="contained"
          autoFocus
        >
          {abortText}
        </Button>
        <Button
          className="confirm-deletion__button"
          size="large"
          onClick={onAgree}
          variant="contained"
          color="primary"
        >
          {inProgress ? <PulseLoader loading color="#fff" sizeUnit="px" size={10} /> : proceedText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDeletionDialog.propTypes = {
  abortText: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  inProgress: PropTypes.bool,
  onAgree: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  proceedText: PropTypes.string,
  title: PropTypes.string,
};

ConfirmDeletionDialog.defaultProps = {
  abortText: 'Cancel',
  body: 'It cannot be restored once deleted.',
  inProgress: false,
  onAgree: () => {},
  onClose: () => {},
  open: false,
  proceedText: 'Delete',
  title: 'Are you sure you want to delete?',
};

export default ConfirmDeletionDialog;
